import React, { useState } from 'react';
import './style.scss';

export default function Lists(props) {
  let { intagramLists, setModal } = props;
  const [state, setState] = useState({
    isOpen: false,
  });

  let toggle = () => {
    setState({ ...state, isOpen: !state.isOpen });
  };

  let getReadMore = () => {
    if (state.isOpen) {
      return (
        <div className="container-card">
          {intagramLists.map((item, i) => (
            <div className="card-hover" key={i} onClick={() => setModal(item.keyIndex, item)}>
              <div className="img" id="img-anim">
                <picture>
                  <picture>
                    <source
                      srcSet={
                        `${item.bigImg.replace('.jpg', '_260x.jpg')} 260w,` +
                        `${item.bigImg.replace('.jpg', '_390x.jpg')} 390w,` +
                        `${item.bigImg.replace('.jpg', '_468x.jpg')} 468w,` +
                        `${item.bigImg.replace('.jpg', '_560x.jpg')} 560w,` +
                        `${item.bigImg.replace('.jpg', '_640x.jpg')} 640w,` +
                        `${item.bigImg.replace('.jpg', '_740x.jpg')} 740w,`
                      }
                    />
                    <img src={item.bigImg.replace('.jpg', '_640x.jpg')} alt={item.alt} loading="lazy" />
                  </picture>
                </picture>
              </div>
              <div className="card-overlay">
                <div className="overlay-center">
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M11.9989 5.84284C8.59165 5.84284 5.84179 8.5927 5.84179 12C5.84179 15.4073 8.59165 18.1572 11.9989 18.1572C15.4063 18.1572 18.1561 15.4073 18.1561 12C18.1561 8.5927 15.4063 5.84284 11.9989 5.84284ZM11.9989 16.0017C9.79546 16.0017 7.99725 14.2035 7.99725 12C7.99725 9.79651 9.79546 7.9983 11.9989 7.9983C14.2024 7.9983 16.0007 9.79651 16.0007 12C16.0007 14.2035 14.2024 16.0017 11.9989 16.0017ZM18.4083 4.1557C17.6127 4.1557 16.9703 4.79813 16.9703 5.59367C16.9703 6.38921 17.6127 7.03164 18.4083 7.03164C19.2038 7.03164 19.8463 6.39221 19.8463 5.59367C19.8465 5.40477 19.8095 5.21767 19.7373 5.0431C19.6651 4.86853 19.5592 4.70992 19.4256 4.57634C19.292 4.44277 19.1334 4.33686 18.9588 4.26468C18.7843 4.1925 18.5972 4.15546 18.4083 4.1557ZM24.0011 12C24.0011 10.3429 24.0161 8.70077 23.923 7.04665C23.8299 5.12536 23.3916 3.4202 21.9867 2.01525C20.5787 0.607302 18.8766 0.172008 16.9553 0.0789456C15.2982 -0.0141173 13.6561 0.000892936 12.002 0.000892936C10.3448 0.000892936 8.70272 -0.0141173 7.04861 0.0789456C5.12731 0.172008 3.42216 0.610305 2.01721 2.01525C0.609256 3.42321 0.173962 5.12536 0.0808987 7.04665C-0.0121641 8.70377 0.00284606 10.3459 0.00284606 12C0.00284606 13.6541 -0.0121641 15.2992 0.0808987 16.9533C0.173962 18.8746 0.612258 20.5798 2.01721 21.9847C3.42516 23.3927 5.12731 23.828 7.04861 23.9211C8.70573 24.0141 10.3478 23.9991 12.002 23.9991C13.6591 23.9991 15.3012 24.0141 16.9553 23.9211C18.8766 23.828 20.5817 23.3897 21.9867 21.9847C23.3946 20.5768 23.8299 18.8746 23.923 16.9533C24.0191 15.2992 24.0011 13.6571 24.0011 12ZM21.3593 19.0788C21.1401 19.6252 20.8759 20.0334 20.4527 20.4537C20.0294 20.877 19.6241 21.1412 19.0777 21.3603C17.4987 21.9877 13.7491 21.8467 11.9989 21.8467C10.2488 21.8467 6.49623 21.9877 4.91717 21.3633C4.3708 21.1442 3.96252 20.88 3.54224 20.4567C3.11895 20.0334 2.85477 19.6282 2.63562 19.0818C2.0112 17.4997 2.1523 13.7502 2.1523 12C2.1523 10.2498 2.0112 6.49728 2.63562 4.91822C2.85477 4.37185 3.11895 3.96357 3.54224 3.54329C3.96552 3.123 4.3708 2.85582 4.91717 2.63667C6.49623 2.01225 10.2488 2.15335 11.9989 2.15335C13.7491 2.15335 17.5017 2.01225 19.0807 2.63667C19.6271 2.85582 20.0354 3.12 20.4557 3.54329C20.879 3.96657 21.1431 4.37185 21.3623 4.91822C21.9867 6.49728 21.8456 10.2498 21.8456 12C21.8456 13.7502 21.9867 17.4997 21.3593 19.0788Z"
                      fill="white"
                    />
                  </svg>
                  <div className="link_btn">
                    <span>Jetzt entdecken</span>
                  </div>
                </div>
              </div>
            </div>
          ))}{' '}
        </div>
      );
    } else {
      return (
        <div className="container-card">
          {intagramLists.slice(0, 20).map((item, i) => (
            <div className="card-hover" key={i} onClick={() => setModal(item.keyIndex, item)}>
              <div className="img" id="img-anim">
                <picture>
                  <source
                    srcSet={
                      `${item.bigImg.replace('.jpg', '_260x.jpg')} 260w,` +
                      `${item.bigImg.replace('.jpg', '_390x.jpg')} 390w,` +
                      `${item.bigImg.replace('.jpg', '_468x.jpg')} 468w,` +
                      `${item.bigImg.replace('.jpg', '_560x.jpg')} 560w,` +
                      `${item.bigImg.replace('.jpg', '_640x.jpg')} 640w,` +
                      `${item.bigImg.replace('.jpg', '_740x.jpg')} 740w,`
                    }
                  />
                  <img src={item.bigImg.replace('.jpg', '_640x.jpg')} alt={item.alt} loading="lazy" />
                </picture>
              </div>
              <div className="card-overlay">
                <div className="overlay-center">
                  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M11.9989 5.84284C8.59165 5.84284 5.84179 8.5927 5.84179 12C5.84179 15.4073 8.59165 18.1572 11.9989 18.1572C15.4063 18.1572 18.1561 15.4073 18.1561 12C18.1561 8.5927 15.4063 5.84284 11.9989 5.84284ZM11.9989 16.0017C9.79546 16.0017 7.99725 14.2035 7.99725 12C7.99725 9.79651 9.79546 7.9983 11.9989 7.9983C14.2024 7.9983 16.0007 9.79651 16.0007 12C16.0007 14.2035 14.2024 16.0017 11.9989 16.0017ZM18.4083 4.1557C17.6127 4.1557 16.9703 4.79813 16.9703 5.59367C16.9703 6.38921 17.6127 7.03164 18.4083 7.03164C19.2038 7.03164 19.8463 6.39221 19.8463 5.59367C19.8465 5.40477 19.8095 5.21767 19.7373 5.0431C19.6651 4.86853 19.5592 4.70992 19.4256 4.57634C19.292 4.44277 19.1334 4.33686 18.9588 4.26468C18.7843 4.1925 18.5972 4.15546 18.4083 4.1557ZM24.0011 12C24.0011 10.3429 24.0161 8.70077 23.923 7.04665C23.8299 5.12536 23.3916 3.4202 21.9867 2.01525C20.5787 0.607302 18.8766 0.172008 16.9553 0.0789456C15.2982 -0.0141173 13.6561 0.000892936 12.002 0.000892936C10.3448 0.000892936 8.70272 -0.0141173 7.04861 0.0789456C5.12731 0.172008 3.42216 0.610305 2.01721 2.01525C0.609256 3.42321 0.173962 5.12536 0.0808987 7.04665C-0.0121641 8.70377 0.00284606 10.3459 0.00284606 12C0.00284606 13.6541 -0.0121641 15.2992 0.0808987 16.9533C0.173962 18.8746 0.612258 20.5798 2.01721 21.9847C3.42516 23.3927 5.12731 23.828 7.04861 23.9211C8.70573 24.0141 10.3478 23.9991 12.002 23.9991C13.6591 23.9991 15.3012 24.0141 16.9553 23.9211C18.8766 23.828 20.5817 23.3897 21.9867 21.9847C23.3946 20.5768 23.8299 18.8746 23.923 16.9533C24.0191 15.2992 24.0011 13.6571 24.0011 12ZM21.3593 19.0788C21.1401 19.6252 20.8759 20.0334 20.4527 20.4537C20.0294 20.877 19.6241 21.1412 19.0777 21.3603C17.4987 21.9877 13.7491 21.8467 11.9989 21.8467C10.2488 21.8467 6.49623 21.9877 4.91717 21.3633C4.3708 21.1442 3.96252 20.88 3.54224 20.4567C3.11895 20.0334 2.85477 19.6282 2.63562 19.0818C2.0112 17.4997 2.1523 13.7502 2.1523 12C2.1523 10.2498 2.0112 6.49728 2.63562 4.91822C2.85477 4.37185 3.11895 3.96357 3.54224 3.54329C3.96552 3.123 4.3708 2.85582 4.91717 2.63667C6.49623 2.01225 10.2488 2.15335 11.9989 2.15335C13.7491 2.15335 17.5017 2.01225 19.0807 2.63667C19.6271 2.85582 20.0354 3.12 20.4557 3.54329C20.879 3.96657 21.1431 4.37185 21.3623 4.91822C21.9867 6.49728 21.8456 10.2498 21.8456 12C21.8456 13.7502 21.9867 17.4997 21.3593 19.0788Z"
                      fill="white"
                    />
                  </svg>
                  <div className="link_btn">
                    <span>Jetzt entdecken</span>
                  </div>
                </div>
              </div>
            </div>
          ))}{' '}
        </div>
      );
    }
  };

  return (
    <div className="cashmere-care-section container-fluid">
      <div className="text-style">
        <h3>#GOBICASHMERE</h3>
        <div className="container-full">{getReadMore()}</div>
        <div className="readMore">
          {intagramLists.length > 20 ? (
            <div className="read-btn" onClick={() => toggle()}>
              {state.isOpen ? 'Mehr ansehen' : ''}
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    </div>
  );
}
